import { TableCard } from '@/components/common/table/TableCard'
import { PaginationFooter } from '@/components/common/table/PaginationFooter'
import { TimeTrackingEntriesDataTable } from './TimeTrackingEntriesDataTable'
import type { TimeTrackingEntriesController } from '../hooks/useTimeTrackingEntries'

interface Props {
  entries: TimeTrackingEntriesController
}

/**
 * Shared table card of the time-tracking list (table + pagination), fed by
 * `useTimeTrackingEntries`. Used identically by the "all time entries" and the
 * employee page — the filters above them differ, the table does not.
 */
export function TimeTrackingEntriesTable({ entries }: Props) {
  return (
    <TableCard>
      <div className="flex-1 overflow-auto scrollbar-custom relative">
        <TimeTrackingEntriesDataTable
          rows={entries.rows}
          isLoading={entries.isLoading}
          isError={entries.isError}
          currentSort={entries.sort}
          currentOrder={entries.order}
          onSort={entries.onSort}
          updatingId={entries.updatingId}
          onUpdateStatus={entries.updateStatus}
        />
      </div>

      <PaginationFooter
        offset={entries.offset}
        limit={entries.limit}
        totalCount={entries.totalCount}
        onOffsetChange={entries.onOffsetChange}
        onPageSizeChange={entries.onPageSizeChange}
      />
    </TableCard>
  )
}
